// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-68179312]{border:.052083rem solid #000;width:100%;padding:1.041667rem}.Application[data-v-68179312]{justify-content:right;margin-bottom:.260417rem}.flex[data-v-68179312]{display:flex;align-items:center}.icons[data-v-68179312]{cursor:pointer}.flexs[data-v-68179312]{display:flex;margin-left:7.8125rem}.content[data-v-68179312]{margin:0 auto;text-align:center}", ""]);
// Exports
module.exports = exports;
